import {ColumnsType} from "antd/lib/table";
import {OrderRefundDto} from "../../api";
import {CrudTableWrapperProps} from "digimuth-components/dist/components/crudTable/crudTable";
import {CrudTable, nameof} from "digimuth-components/dist";
import {Tag} from "antd";
import moment from "moment";

interface OrderRefundListProps extends CrudTableWrapperProps<OrderRefundDto> {
    submitDisabled: boolean,
    orderRefundsSum: number;
}

export default function OrderRefundsList(props: OrderRefundListProps) {
    const columns: ColumnsType<OrderRefundDto> = [
        {
            key: nameof<OrderRefundDto>("refundId"),
            dataIndex: nameof<OrderRefundDto>("refundId"),
            title: "ID zwrotu"
        },
        {
            key: nameof<OrderRefundDto>("creationDateTime"),
            dataIndex: nameof<OrderRefundDto>("creationDateTime"),
            title: "Data utworzenia zwrotu",
            render: value => moment(value).format("YYYY-MM-DD HH:mm:ss")
        },
        {
            key: nameof<OrderRefundDto>("description"),
            dataIndex: nameof<OrderRefundDto>("description"),
            title: "Opis"
        },
        {
            key: nameof<OrderRefundDto>("amount"),
            dataIndex: nameof<OrderRefundDto>("amount"),
            title: "Kwota (zł)",
            render: value => value / 100
        },
        {
            key: nameof<OrderRefundDto>("currencyCode"),
            dataIndex: nameof<OrderRefundDto>("currencyCode"),
            title: "Waluta"
        },
        {
            key: nameof<OrderRefundDto>("status"),
            dataIndex: nameof<OrderRefundDto>("status"),
            title: "Status",
            render: value => {
                if (value === "PENDING") return <Tag color={"yellow"}>W trakcie</Tag>
                else if (value === "FINALIZED") return <Tag color={"green"}>Zrealizowany</Tag>
                return <Tag color={"red"}>Anulowany</Tag>
            }
        },
        {
            key: nameof<OrderRefundDto>("statusDateTime"),
            dataIndex: nameof<OrderRefundDto>("statusDateTime"),
            title: "Zmiana statusu",
            render: value => moment(value).format("YYYY-MM-DD HH:mm:ss")
        },
        {
            key: nameof<OrderRefundDto>("statusCode"),
            dataIndex: nameof<OrderRefundDto>("statusCode"),
            title: "Kod statusu"
        },
        {
            key: nameof<OrderRefundDto>("statusDescription"),
            dataIndex: nameof<OrderRefundDto>("statusDescription"),
            title: "Opis statusu"
        },
    ];

    return <CrudTable
        submitButtonProps={{disabled: props.submitDisabled}}
        data={props.data}
        onAddClicked={props.onAddClicked}
        isLoading={props.isLoading}
        columns={columns}
        addButtonTitle={"+ Dodaj nowy zwrot"}
        tableProps={{
            footer: () => <div>
                <strong>Suma zwrotów:</strong>&nbsp;
                {props.orderRefundsSum} zł
            </div>
        }}
    />;
}
